"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LE_SESSION_ID_KEY = exports.LE_VISITOR_ID_KEY = exports.LE_CONVERSATION_SEQUENCE_NUMBER_KEY = exports.LE_CONVERSATION_ID_KEY = exports.LE_INTERNAL_TOKEN_KEY = exports.LE_EXTERNAL_TOKEN_KEY = exports["default"] = void 0;

var _constants = require("../constants");

var _LiveEngageProductSkills = _interopRequireDefault(require("./LiveEngageProductSkills"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var config = function config(env, product) {
  env = env || _constants.ENV_STRINGS.dev;
  var isProd = env === _constants.ENV_STRINGS.prod;
  var envHostPrefix = {
    prod: '',
    dev: "".concat(_constants.ENV_STRINGS.dev, "-"),
    test: "".concat(_constants.ENV_STRINGS.test, "-")
  }[env];
  var currentSkillMap = _LiveEngageProductSkills["default"][env];
  var defaultSkill = currentSkillMap.find(function (item) {
    return item.product === _constants.PRODUCT_DEFAULT;
  });
  var productSkill = currentSkillMap.find(function (item) {
    return item.product === product;
  });
  var cfg = {
    accountId: isProd ? '30187337' : '5945340',
    agentConnectTimeoutMs: 30000,
    appInstallationId: isProd ? '2ebea20d-acbd-488c-b458-715236de63aa' : '1461f7fd-a6c8-4dc1-8153-210ac580c894',
    lpConnectorId: isProd ? '1492220914' : '1649764530',
    domainAsyncMessagingEnt: 'va.msg.liveperson.net',
    domainIdp: 'va.idp.liveperson.net',
    domainMsdkgw: 'va.v.liveperson.net',
    skillId: productSkill ? productSkill.skillId : defaultSkill.skillId,
    skillName: productSkill ? productSkill.skillName : defaultSkill.skillName,
    keepAliveInterval: 30000,
    socketUrl: '',
    authorizeUrl: '',
    authenticateUrl: '',
    engagementUrl: '',
    chatbotsApiUrl: '',
    retries: 5,
    retryInterval: 1000
  };
  cfg.socketUrl = "wss://".concat(cfg.domainAsyncMessagingEnt, "/ws_api/account/").concat(cfg.accountId, "/messaging/consumer?v=3");
  cfg.authorizeUrl = "https://".concat(cfg.domainIdp, "/api/account/").concat(cfg.accountId, "/anonymous/authorize");
  cfg.authenticateUrl = "https://".concat(cfg.domainIdp, "/api/account/").concat(cfg.accountId, "/app/").concat(cfg.lpConnectorId, "/authenticate?v=3.0");
  cfg.engagementUrl = "https://".concat(cfg.domainMsdkgw, "/api/account/").concat(cfg.accountId, "/app/").concat(cfg.appInstallationId, "/engagement?v=1.0");
  cfg.chatbotsApiUrl = "https://".concat(_constants.API_HOST, ".").concat(envHostPrefix, "godaddy.com");
  return cfg;
};

var _default = config;
exports["default"] = _default;
var LE_EXTERNAL_TOKEN_KEY = 'LEExternalToken';
exports.LE_EXTERNAL_TOKEN_KEY = LE_EXTERNAL_TOKEN_KEY;
var LE_INTERNAL_TOKEN_KEY = 'LEInternalToken';
exports.LE_INTERNAL_TOKEN_KEY = LE_INTERNAL_TOKEN_KEY;
var LE_CONVERSATION_ID_KEY = 'LEConversationId';
exports.LE_CONVERSATION_ID_KEY = LE_CONVERSATION_ID_KEY;
var LE_CONVERSATION_SEQUENCE_NUMBER_KEY = 'LEConversationSequenceNumber';
exports.LE_CONVERSATION_SEQUENCE_NUMBER_KEY = LE_CONVERSATION_SEQUENCE_NUMBER_KEY;
var LE_VISITOR_ID_KEY = 'LEVisitorId';
exports.LE_VISITOR_ID_KEY = LE_VISITOR_ID_KEY;
var LE_SESSION_ID_KEY = 'LESessionId';
exports.LE_SESSION_ID_KEY = LE_SESSION_ID_KEY;